/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */
import { BitFlags } from '../../../../mol-util';
export { DSSPType };
var DSSPType;
(function (DSSPType) {
    DSSPType.is = BitFlags.has;
    DSSPType.create = BitFlags.create;
})(DSSPType || (DSSPType = {}));
var Bridge = /** @class */ (function () {
    function Bridge(p1, p2, type) {
        this.partner1 = Math.min(p1, p2);
        this.partner2 = Math.max(p1, p2);
        this.type = type;
    }
    return Bridge;
}());
export { Bridge };
